import React, { useState, useEffect, useRef } from "react";
import SimpleBar from "simplebar-react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSSTransition } from "react-transition-group";
// import { Transition } from "react-transition-group";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
 
  faSignOutAlt,
  faTimes,
  faBars,
  faCaretDown,
  faCaretUp,
} from "@fortawesome/free-solid-svg-icons";
import {
  Nav,
  Image,
  Button,
  Dropdown,
  Navbar,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "../routes";
import ReactHero from "../assets/img/kano.png";
import ProfilePicture from "../assets/img/default_avatar.png";
// import { faGratipay } from "@fortawesome/free-brands-svg-icons";
import { useSelector } from "react-redux";
import { mainTreasuryModules } from "../pages/examples/user-admin/modules";
export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const showClass = show ? "show" : "";
  const user = useSelector((state) => state.auth.user);
  const history = useNavigate();
  // const [show, setShow] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState([]);

  const onCollapse = () => setShow(!show);

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null, subMenu = [] } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";
    const [isOpen] = useState(defaultKey === eventKey);

    const isDropdownOpen = (eventKey) => openDropdowns.includes(eventKey);

    const handleDropdownToggle = (eventKey) => {
      const index = openDropdowns.indexOf(eventKey);
      if (index === -1) {
        setOpenDropdowns([...openDropdowns, eventKey]);
      } else {
        setOpenDropdowns(openDropdowns.filter(key => key !== eventKey));
      }
    };

    const renderMenuItem = (item, parentKey, index) => {
      const itemKey = `${parentKey}-${index}`;
      
      if (item.subMenu && item.subMenu.length) {
      return (
        <div key={itemKey} className="ps-3">
        <Nav.Item onClick={() => handleDropdownToggle(itemKey)}>
          <Nav.Link className="d-flex justify-content-between align-items-center">
          <span>
            {item.icon && (
            <span className="sidebar-icon">
              <FontAwesomeIcon icon={item.icon} />{" "}
            </span>
            )}
            <span className="sidebar-text">
            {item.title}
            </span>
          </span>
          <FontAwesomeIcon
            icon={isDropdownOpen(itemKey) ? faCaretUp : faCaretDown}
            className="ms-1"
          />
          </Nav.Link>
        </Nav.Item>
        {isDropdownOpen(itemKey) && (
          <Nav className="flex-column ps-3">
          {item.subMenu.map((subItem, subIndex) => 
            renderMenuItem(subItem, itemKey, subIndex)
          )}
          </Nav>
        )}
        </div>
      );
      }

      return (
      <NavItem
        key={itemKey}
        title={item.title}
        link={item.route}
        icon={item.icon}
      />
      );
    };

    return (
      <div>
        <Nav.Item onClick={() => handleDropdownToggle(eventKey)}>
          <Nav.Link className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon">
                <FontAwesomeIcon icon={icon} />{" "}
              </span>
              <span className="sidebar-text">
                {title}
              </span>
            </span>
            <FontAwesomeIcon
              icon={isDropdownOpen(eventKey) ? faCaretUp : faCaretDown}
              className="ms-1"
            />
          </Nav.Link>
        </Nav.Item>
        {isDropdownOpen(eventKey) && (
          <Nav className="flex-column ps-3">
            {subMenu.map((item, index) => renderMenuItem(item, eventKey, index))}
            {children}
          </Nav>
        )}
      </div>
    );
  };


  ////latest
  const NavItem = (props) => {
    // const [isLoading, setIsLoading] = useState(false); //loading

    const { title, link, badgeText, icon } = props;

    // const handleNavItemClick = () => {
    //   setIsLoading(true);
    //   setTimeout(() => {
    //     setIsLoading(false);
    //     history(link);
    //   }, 10000);
    // };

    const classNames = badgeText
      ? "d-flex justify-content-start align-items-center justify-content-between"
      : "";

    const isActive = location.pathname.includes(link);
     
    return (
      <div
        onClick={() => {
          setShow(!show);
          history(link)
        }}
        style={{ cursor: "pointer" }}
        className={`${isActive ? "bg-success" : ""} py-2 px-2 rounded`}
      >
        <span className="sidebar-icon">
          <FontAwesomeIcon icon={icon} />
        </span>
        {title}
      </div>
    );
  };

  return (
    <>
      <Navbar
        color="success"
        expand={false}
        collapseOnSelect
        variant="primary"
        className="navbar-theme-success px-3 d-md-none"
      >
        <Navbar.Brand
          className="me-lg-5"
          as={Link}
          to={Routes.DashboardOverview.path}
        >
          <Image src={ReactHero} height={55} style={{height: 45}} />
        </Navbar.Brand>
        <Navbar.Toggle
          as={Button}
          aria-controls="main-navbar"
          onClick={onCollapse}
         
        >
        
          <span className="navbar-toggler-icon" >
              <FontAwesomeIcon icon={faBars} className="w-100 h-100" />
          </span>
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}
        >
          <div className="sidebar-inner px-2 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image
                    src={ProfilePicture}
                    className="card-img-top rounded-circle border-white"
                  />
                </div>
                <div className="d-block">
                  <h6>Hi, {user.username}</h6>
                  <Button
                    as={Link}
                    variant="secondary"
                    size="xs"
                    to={Routes.Signin.path}
                    className="text-dark"
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />{" "}
                    Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link
                className="collapse-close d-md-none"
                onClick={onCollapse}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              <div onClick={() => history("/")} className="text-center">
                <Image
                  style={{
                    cursor: "pointer",
                    marginBottom: 10,
                    marginRight: 10,
                  }}
                  src={ReactHero}
                  height={100}
                  width={220}
                />
                {/* <span className="sidebar-text">KIFMIS</span> */}
              </div>

                {mainTreasuryModules.map((module, index) => {
                const modKey = module.title.split(" ").join("-");
                if (module.subMenu && module.subMenu.length) {
                  if (user.accessTo && user.accessTo.includes(module.title)) {
                  return (
                    <div key={index}>
                    <CollapsableNavItem
                      eventKey={modKey}
                      title={module.title}
                      icon={module.icon}
                      subMenu={module.subMenu}
                    >
                      {/* {module.subMenu.map((item, idx) => {
                      if (
                        user.functionalities &&
                        user.functionalities.includes(item.title)
                      ) {
                        if (item.subMenu && item.subMenu.length) {
                        return (
                          <CollapsableNavItem
                          key={`${modKey}-${idx}`}
                          eventKey={`${modKey}-${idx}`}
                          title={item.title}
                          icon={item.icon}
                          subMenu={item.subMenu}
                          >
                          {item.subMenu.map((subItem, subIdx) => (
                            <NavItem
                            key={`${modKey}-${idx}-${subIdx}`}
                            title={subItem.title}
                            link={subItem.route}
                            icon={subItem.icon}
                            onClick={onCollapse}
                            />
                          ))}
                          </CollapsableNavItem>
                        );
                        }
                        
                      }
                      return null;
                      })} */}
                    </CollapsableNavItem>
                    </div>
                  );
                  }
                  return null;
                }
                if (user.accessTo && user.accessTo.includes(module.title)) {
                  return (
                  <Nav Item
                    title={module.title}
                    link={module.route}
                    key={module.key}
                    onClick={onCollapse}
                  />
                  );
                }
                return null;
                })}

              <Dropdown.Divider className="my-3 border-indigo" />
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};